export const MAX_FILE_SIZE = 10_485_760; // 10MB
export const ALLOWED_EXTENTIONS_FILE = ["jpg", "jpeg", "png"];

export const ERROR_SIZE_MESSAGE = "JPEG, JPG or PNG format only up to 10 Mb.";
export const ERROR_ALLOWED_EXTENTION_MESSAGE =
  "JPEG, JPG or PNG format up to 10 Mb.";
export const ERROR_MESSAGE =
  "Drop file here or clicks to upload. JPEG, JPG or PNG format up to 10 MB";
